// src/components/NotFound.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = ({ user }) => {
  const navigate = useNavigate();
  const nombreUsuario = user?.nombre || "Usuario";

  return (
    <div className="container vh-100 d-flex justify-content-center align-items-center">
      <div className="text-center p-5 shadow-lg rounded-4 border border-light">
        <h1 className="display-1 fw-bold text-primary">404</h1>
        <h2 className="mb-4">¿Te perdiste, {nombreUsuario}?</h2>
        
        <div className="d-grid gap-3 d-md-flex justify-content-md-center">
          {/* USAR onClick con navigate, NUNCA href */}
          <button 
            onClick={() => navigate(-1)} 
            className="btn btn-outline-secondary btn-lg"
          >
            Volver atrás
          </button>
          
          <button 
            onClick={() => navigate('/home')} 
            className="btn btn-primary btn-lg"
          >
            Ir al Menú Principal
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;